import { type Meta } from '../types/docs';
import { UPLOAD_ANALYTICS_COMMON_META_PARAMS } from './uploadAnalyticsMetaParams';

const META: Meta = {
  description: 'A multipart upload part started transferring',
  name: 'upload_part_started',
  params: [
    ...UPLOAD_ANALYTICS_COMMON_META_PARAMS,
    {
      description: 'One-indexed multipart part number',
      name: 'part_number',
      required: true,
      type: 'number',
    },
    {
      description: 'Part size in bytes',
      name: 'part_size_bytes',
      required: false,
      type: 'number',
    },
    {
      description: 'Retry attempt for this part transfer. Initial transfer is 0.',
      name: 'retry_count',
      required: true,
      type: 'number',
    },
    {
      description: 'Maximum retry count configured for multipart parts',
      name: 'max_retry_count',
      required: false,
      type: 'number',
    },
    {
      description: 'Why this part transfer started',
      name: 'start_reason',
      required: true,
      type: 'enum',
      values: ['initial', 'retry'],
    },
    {
      description: 'Which presigned URL type the part transfer used',
      name: 'upload_url_type',
      required: true,
      type: 'enum',
      values: ['primary', 'fallback'],
    },
  ],
};

export default META;
